/* eslint-disable no-unreachable */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import {
  BathroomIcon,
  BedIcon,
  FavoriteIcon,
  HeardIcon,
  LeftArrowIcon,
  NoteIcon,
  PossibilityIcon,
  RightArrowIcon,
  RightArrowIconCircle,
  LeftArrowIconCircle,
  SavedIcon,
  ImagesIcon,
} from "../../constants/icons.jsx";
import "./houseCardGallery.css";
import "./responsive.css";
import Slider from "react-slick";
import axios from "axios";
import Spiner from "../../ui/spiner/spiner.jsx";
import HouseCardHeardList from "../HouseCardHeardList/HouseCardHeardList.jsx";
import HeardTextarea from "../HeardTextarea/HeardTextarea";
import NoteContentPopUp from "../NoteContentPopUp/NoteContentPopUp.jsx";
import ShareIconList from "../ShareIconList/ShareIconList.jsx";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import lightgallery from "lightgallery";
import { AlertNote } from "../../ui/index.js";
import NotesBox from "../NotesBox/NotesBox.jsx";
import OpenHouse from "../OpenHouse/OpenHouse";
import ClickOutside from "../../ui/clickOutside/clickoutSideComponent.jsx";
import BAWithTooltip from "../BAWithTooltip/BAWithTooltip.jsx";
import { MachineDateToUSDate } from "../../constants/methods.js";
// import $ from "jquery";
// import LightGallery from "lightgallery/react";
// import "lightgallery/css/lightgallery.css";
// import "lightgallery/css/lg-zoom.css";
// import "lightgallery/css/lg-thumbnail.css";

const HouseCardGallery = ({
  item,
  heardData,
  setHeardData,
  listingsData,
  images,
  isLogin,
  container,
  isPicturesFeature,
}) => {
  let k = <HeardIcon />;

  const [isHeardActive, setIsHeardActive] = useState(false);

  const [currentSlide, setCurrentSlide] = useState(1);
  const [note, setNote] = useState(null);
  const [noteBox, setNoteBox] = useState(null);
  const [alertBox, setAlertBox] = useState(false);
  const [alertNoUserBox, setAlertNoUserBox] = useState(false);
  const [alertNoUserMessageBox, setAlertNoUserMessageBox] = useState(false);
  const [isNoteContentBox, setIsNoteContentBox] = useState(false);
  const [isNoteIconShow, setIsNoteIconShow] = useState(false);
  const [notesData, setNotesData] = useState(null);
  const [showOpenHouse, setShowOpenHouse] = useState(false);
  const [listingImages, setListingImages] = useState([]);
  const [listingGallery, setListingGallery] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);

  const [isAcceptBtnPress, setIsAcceptBtnPress] = useState(false);
  const galleryEl = document?.getElementById(
    "active-listings-house-card-lightgallery-modal"
  );

  useEffect(() => {
    // if (isPicturesFeature === "true" || isLogin) {
    if (isPicturesFeature === "true") {
      const divs = document.getElementsByClassName("lg-thumb-item");
      const divs2 = document.getElementsByClassName("lg-item");
      const divs3 = document.getElementsByClassName("lg-current")[0];
      const divsImg3 = divs3?.getElementsByClassName("lg-image")[0];
      const divsBtn = document.getElementsByClassName(
        "unlock-main-images-button"
      );
      for (let index = 0; index < divsBtn.length; index++) {
        const element = divsBtn[index];
        if (element) element.style.display = "none";
      }

      if (divsImg3) divsImg3.style.filter = "blur(0px)";
      for (let index = 0; index < divs.length; index++) {
        const element = divs[index];
        const element2 = divs2[index];
        if (element2) element2.classList.remove("blur-image");
        if (element) element.style.filter = "blur(0px)";
      }
    } else {
      const divs = document.getElementsByClassName("lg-thumb-item");
      const divs3 = document.getElementsByClassName("lg-current")[0];
      const divsImg3 = divs3?.getElementsByClassName("lg-image")[0];
      const divsBtn = document.getElementsByClassName(
        "unlock-main-images-button"
      );
      for (let index = 0; index < divsBtn.length; index++) {
        const element = divsBtn[index];
        if (element) element.style.display = "block";
      }
      if (divsImg3) divsImg3.style.filter = "blur(5px)";
      for (let index = 0; index < divs.length; index++) {
        const element = divs[index];
        if (element) element.style.filter = "blur(5px)";
      }
    }
  }, [isPicturesFeature]);

  const listingSlider = container;
  const isHeardVisible = listingSlider?.getAttribute("data-hearth-icon");

  const [initPicturesFeature, setInitPicturesFeature] = useState(null);

  // const isUserlogin = () => {
  //   let islogin = localStorage.getItem("MyRTP");
  //   if (islogin && JSON.parse(islogin) === true) {
  //     return true;
  //   }
  //   return false;
  // };

  let lgContent = undefined;
  galleryEl?.addEventListener("lgBeforeOpen", (e) => {
    if (!lgContent) {
      lgContent = document.querySelector(".lg-container.lg-content");
    }
    if (lgContent) {
      let unlockPremiumFeatures = lgContent.querySelector(
        "button.unlock-main-images-button"
      );
      if (!unlockPremiumFeatures) {
        unlockPremiumFeatures = document.createElement("button");
        unlockPremiumFeatures.style = `position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 10px 20px;
        background-color: #007bff;
        color: white;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        display:none;
        font-size: 200%;
        z-index: 99999999999;`;
        unlockPremiumFeatures.classList.add("unlock-main-images-button");
        unlockPremiumFeatures.innerHTML = "Click for Premium Access";
        unlockPremiumFeatures.addEventListener("click", (event) => {
          const RTUnlockPremiumFeaturesEvent = new CustomEvent(
            "RTUnlockPremiumFeatures",
            {
              detail: {
                element: event.currentTarget,
              },
            }
          );
          document.dispatchEvent(RTUnlockPremiumFeaturesEvent);
        });
        lgContent.append(unlockPremiumFeatures);
      }
    }
  });

  const acceptLoginBtnHandler = () => {
    const RTUnlockPremiumFeaturesEvent = new CustomEvent(
      "RTUnlockPremiumFeatures",
      {
        detail: {
          element: ref,
        },
      }
    );
    document.dispatchEvent(RTUnlockPremiumFeaturesEvent);
  };

  // useEffect(() => {
  //   if (isAcceptBtnPress) acceptLoginBtnHandler();
  // }, [isAcceptBtnPress]);

  galleryEl?.addEventListener("lgBeforeOpen", (e) => {
    const tunel = document.querySelector(".lg-thumb.lg-group");
    const myRTP = localStorage.getItem("MyRTP");
    // if (tunel && (isPicturesFeature === "true" || myRTP === null)) {
    // if (tunel)
    if (isPicturesFeature !== "true") {
      tunel?.classList.add("blur-image");
    } else {
      tunel?.classList.remove("blur-image");
    }
  });

  galleryEl?.addEventListener("lgAfterOpen", (e) => {
    const tunel = document.querySelector(".lg-thumb.lg-group");
    const myRTP = localStorage.getItem("MyRTP");
    // if (tunel && (isPicturesFeature === "true" || myRTP === null)) {
    // if (tunel)
    if (isPicturesFeature !== "true") {
      tunel?.classList.add("blur-image");
    } else {
      tunel?.classList.remove("blur-image");
    }
  });

  galleryEl?.addEventListener("lgAfterSlide", (e) => {
    setPageNumber(e.detail.index);
  });

  galleryEl?.addEventListener("lgBeforeSlide", (e) => {
    const initPF = container?.getAttribute("pictures-feature");
    const slideIndex = e.detail.index;
    // const tunel = document.querySelector(".lg-thumb.lg-group");
    // const tunelImage = tunel.getElementsByClassName("lg-thumb-item");

    // if (tunel && !isUserlogin()) {
    //   for (let i = 5; i < tunelImage.length; i++) {
    //     const element = tunelImage[i];
    //     element.classList.add("blur-image");
    //   }
    // }
    const myRTP = localStorage.getItem("MyRTP");
    // if (isPicturesFeature === "true" || myRTP === null) {
    if (initPF !== "true") {
      const currentSlide = document.querySelector(".lg-item.lg-current");
      const currentPicture = currentSlide.querySelector("img");
      if (currentPicture) {
        currentPicture.style.filter = "blur(5px)";
        currentPicture.parentElement.parentElement.classList.add("blur-image");
      }
      let unlockBtns = document.querySelectorAll(
        "button.unlock-main-images-button"
      );
      if (unlockBtns) {
        unlockBtns.forEach((element) => {
          element.style.display = "block";
        });
      }
    } else {
      // Remove the blur effect from previous images
      const slides = document.querySelectorAll(".lg-item");
      slides.forEach(function (slide) {
        const picture = slide.querySelector("img");
        if (picture) {
          picture.classList.remove("blur-image");
        }
      });
      let unlockBtns = document.querySelectorAll(
        "button.unlock-main-images-button"
      );
      if (unlockBtns) {
        unlockBtns.forEach((element) => {
          element.style.display = "none";
        });
      }
    }

    // if (!isUserlogin()) {
    //   const allImages = document.querySelectorAll(".lg-item img");

    //   // Loop through images and apply the blur effect to images after the 5th image
    //   allImages.forEach((image, index) => {
    //     if (index >= 5 && (index === slideIndex || index === slideIndex + 1)) {
    //       image.classList.add("blur-image");
    //     } else {
    //       image.classList.remove("blur-image");
    //     }
    //   });
    // }
  });

  galleryEl?.addEventListener("lgAfterSlide", (e) => {
    const slideIndex = e.detail.index;
    const initPF = container?.getAttribute("pictures-feature");
    const myRTP = localStorage.getItem("MyRTP");
    // if (slideIndex >= 0 && (isPicturesFeature === "true" || myRTP === null)) {
    if (initPF !== "true") {
      const currentSlide = document.querySelector(".lg-item.lg-current");
      const currentPicture = currentSlide.querySelector("img");
      if (currentPicture) {
        currentPicture.style.filter = "blur(5px)";
        currentPicture.parentElement.parentElement.classList.add("blur-image");
      }
    } else {
      // Remove the blur effect from previous images
      const slides = document.querySelectorAll(".lg-item");
      slides.forEach(function (slide) {
        const picture = slide.querySelector("img");
        if (picture) {
          picture.classList.remove("blur-image");
        }
      });
    }
  });

  useEffect(() => {
    if (listingImages.length > 0) {
      setListingGallery(
        lightgallery(galleryEl, {
          licenseKey: "FDFE7CA7-1DB9-4844-9ADB-DC3BF2EB2450",
          plugins: [lgThumbnail],
          thumbnail: true,
          dynamic: true,
          dynamicEl: [],
          preload: listingImages.length,
          numberOfSlideItemsInDom: listingImages.length,
          width: "700px",
          height: "470px",
          mode: "lg-fade",
          addClass: "listing-gallery-size",
          counter: true,
          download: false,
          startClass: "",
          enableSwipe: true,
          enableDrag: true,
          speed: 500,
        })
      );
    }
  }, [listingImages]);

  useEffect(() => {
    if (images) {
      setListingImages(
        images.map((img) => ({
          ...img, // ✅ Creates a new object instead of modifying the existing one
          src: img.MediaURL,
          subHtml: `<p>${img.LongDescription ? img.LongDescription : ""}</p>`,
          thumb: img.MediaURL,
        }))
      );
    }
  }, [images]);

  const ref = useRef();

  const onCLickImgSlider = (number, e) => {
    const isBtnClick = e.target.classList.contains(
      "active-listings-house-card-gallery-no-login-btn"
    );
    // let listingGallery = lightgallery(galleryEl, {
    //   licenseKey: "FDFE7CA7-1DB9-4844-9ADB-DC3BF2EB2450",
    //   plugins: [lgThumbnail],
    //   thumbnail: true,
    //   dynamic: true,
    //   dynamicEl: listingImages,
    //   preload: listingImages.length,
    //   numberOfSlideItemsInDom: listingImages.length,
    //   width: "700px",
    //   height: "470px",
    //   mode: "lg-fade",
    //   addClass: "listing-gallery-size",
    //   counter: true,
    //   download: false,
    //   startClass: "",
    //   enableSwipe: true,
    //   enableDrag: true,
    //   speed: 500,
    // });
    listingGallery.refresh(listingImages);
    if (listingGallery && !isBtnClick) {
      listingGallery.openGallery(number);
    }
  };

  const onHeardIconHandler = () => {
    setIsHeardActive(true);
    setAlertBox(false);
  };

  const onNoteContentIconHandler = () => {
    setNoteBox(true);
    // setIsNoteContentBox(true);
    // getNotes();
  };

  const getNotes = () => {
    axios
      .get(
        `https://realtytexas.azureedge.net/api/v1/listings/${item?.ListingKeyNumeric}/notes`
      )
      .then(function (response) {
        if (response.data.data?.data?.length > 0) {
          setNotesData(response.data.data);
        } else setNotesData(null);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const setSliderCounter = (slide) => {
    setCurrentSlide(slide);
  };

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => {
    return (
      <button
        {...props}
        style={{ opacity: 0.75 }}
        className={
          "slick-arrow active-listings-house-card-gallery-slider-left-arrow" +
          (currentSlide === slideCount - 1 ? " slick-disabled" : "")
        }
        // aria-hidden="true"
        aria-disabled={currentSlide === 0 ? true : false}
        type="button"
        aria-label="Previous image button"
      >
        <RightArrowIconCircle color="white" width="33" height="33" />
      </button>
    );
  };
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      style={{ opacity: 0.75 }}
      className={
        "slick-arrow active-listings-house-card-gallery-slider-right-arrow" +
        (currentSlide === slideCount - 1 ? " slick-disabled" : "")
      }
      //   aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
      type="button"
      aria-label="Next image button"
    >
      <LeftArrowIconCircle color="white" width="33" height="33" />
    </button>
  );

  const handleImageLoad = (index, isPicturesFeature, acceptLoginBtnHandler) => {
    //START LOAD THE NEXT ONE AND PREV ONE IMG
    const imgArray = images ? [...images].sort((a, b) => parseFloat(a.order) - parseFloat(b.order)) : [];

    const mainWrapper = document.querySelectorAll(
      ".active-listings-house-card-gallery-wrapper"
    )[0];

    const imgWrapper = document.createElement("div");
    const imgWrapperPrev = document.createElement("div");
    imgWrapper.className = "fake-img";
    imgWrapperPrev.className = "fake-img";
    const imgDiv = document.createElement("div");
    const imgDivPrev = document.createElement("div");
    imgDiv.className = "active-listings-house-card-gallery-img-container";
    imgDivPrev.className = "active-listings-house-card-gallery-img-container";
    const imgNext = document.createElement("img");
    const imgPrev = document.createElement("img");

    // {i >= 0 && (
    //   <div
    //     style={{
    //       display:
    //         // isPicturesFeature === "true" || isLogin
    //         isPicturesFeature === "true" ? "none" : "block",
    //     }}
    //     className="active-listings-house-card-gallery-no-login-btn"
    //     onClick={acceptLoginBtnHandler}
    //   >
    //     Click for Premium Access
    //   </div>
    // )}

    if (isPicturesFeature !== "true") {
      imgNext.classList.add("blur-image-inline-slider");
      imgPrev.classList.add("blur-image-inline-slider");

      const noLoginBtnDiv = document.createElement("div");
      noLoginBtnDiv.classList.add(
        "active-listings-house-card-gallery-no-login-btn"
      );
      noLoginBtnDiv.innerHTML += "Click for Premium Access";
      noLoginBtnDiv.onclick = acceptLoginBtnHandler;

      const noLoginBtnDivPrev = document.createElement("div");
      noLoginBtnDivPrev.classList.add(
        "active-listings-house-card-gallery-no-login-btn"
      );
      noLoginBtnDivPrev.innerHTML += "Click for Premium Access";
      noLoginBtnDivPrev.onclick = acceptLoginBtnHandler;

      imgDiv.append(noLoginBtnDiv);
      imgDivPrev.append(noLoginBtnDivPrev);
    }

    //next
    const nextSrc = imgArray[index + 1]?.MediaURL;
    if (nextSrc) {
      imgNext.src = nextSrc;
      imgNext.loading = "eager";
      imgDiv.append(imgNext);
      imgWrapper.append(imgDiv);
      const currentDivNext =
        mainWrapper?.querySelectorAll(".slick-current")[0]?.nextElementSibling;

      if (currentDivNext) {
        const el = currentDivNext?.querySelectorAll(".fake-img")[0];
        if (!el) {
          currentDivNext.append(imgWrapper);
        } else {
          el.remove();
          currentDivNext.append(imgWrapper);
        }
      }
    }

    //prev

    if (index !== 0) {
      imgPrev.src = imgArray[index - 1]?.MediaURL;
    } else {
      imgPrev.src = imgArray[imgArray.length - 1]?.MediaURL;
    }

    imgPrev.loading = "eager";

    imgDivPrev.append(imgPrev);

    imgWrapperPrev.append(imgDivPrev);

    const currentDivPrev =
      document.querySelectorAll(".slick-current")[0]?.previousElementSibling;

    if (currentDivPrev) {
      const el = currentDivPrev?.querySelectorAll(".fake-img")[0];
      if (!el) {
        currentDivPrev.append(imgWrapperPrev);
      } else {
        el.remove();
        currentDivPrev.append(imgWrapperPrev);
      }
    }
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    useCSS: false,
    // lazyLoad: "ondemand",
    lazyLoad: true,
    nextArrow: <SlickArrowLeft />,
    prevArrow: <SlickArrowRight />,
    afterChange: (index) => setCurrentSlide(index + 1),
    // beforeChange: (slide) => {
    //   setCurrentSlide(slide + 1);
    // },
  };

  useEffect(() => {
    getIcon();
  }, [heardData]);

  useEffect(() => {
    if (item.total_notes > 0) {
      setIsNoteIconShow(true);
    } else {
      setIsNoteIconShow(false);
    }
  }, [listingsData]);

  //need to add check to display note icon here
  const getIcon = () => {
    heardData?.map((ob, i, arr) => {
      if (ob?.id === item?.ListingKeyNumeric) {
        // if (ob.value === 1) {
        //   k = <SavedIcon key={i} />;
        // } else {
        if (ob.value === 2) {
          k = <FavoriteIcon key={i} />;
        } else {
          if (ob.value === 3) {
            k = <PossibilityIcon key={i} />;
          } else {
            if (ob.value === -1) {
              k = <NoteIcon key={i} />;
            } else {
              k = <HeardIcon key={i} />;
            }
          }
        }
      }
      if (item.ListingKeyNumeric && item.GatewayDescID !== null) {
        // dispatch(
        //   updateHouseCardsHeardData({
        //     id: item.ListingKeyNumeric,
        //     value: item.GatewayDescID,
        //   })
        // );
      }
    });
    return k;
  };

  const logInLinkHandler = () => {
    document
      ?.getElementById("root-react-login-form")
      ?.setAttribute("visible", "true");
  };

  const defaultImg =
    "https://realtytexas.azureedge.net/assets/images/placeholder-image.jpg";

  function initHeardHandler() {
    const myRTP = JSON?.parse(localStorage?.getItem("MyRTP"));
    if (isLogin || myRTP?.SubjectID) {
      onHeardIconHandler();
    } else {
      logInLinkHandler();
    }
  }

  const [isRI, setIsRI] = useState(false);

  const clickRealtyIconHandler = () => {
    setIsRI(!isRI);
  };

  const clickOutsideHandler = () => {
    setIsRI(false);
  };
  return (
    <div className="active-listings-house-card-gallery-wrapper">
      <div
        id="active-listings-house-card-gallery-img-lightgallery"
        className="active-listings-house-card-gallery-img"
      >
        {showOpenHouse && item?.OpenHouse?.length > 0 ? (
          <OpenHouse
            OpenHouseData={item?.OpenHouse}
            item={item}
            closeWrapper={setShowOpenHouse}
          />
        ) : (
          ""
        )}

        <AlertNote isVisible={alertBox} setIsVisible={setAlertBox} />
        <AlertNote
          isVisible={alertNoUserBox}
          setIsVisible={setAlertNoUserBox}
          text={
            <>
              To synchronize your listings actions across all devices, please{" "}
              <span
                className="active-listings-house-card-note-link"
                onClick={() => logInLinkHandler()}
              >
                create
              </span>{" "}
              an account or{" "}
              <span
                className="active-listings-house-card-note-link"
                onClick={() => logInLinkHandler()}
              >
                log in
              </span>
              .
            </>
          }
        />
        <AlertNote
          isVisible={alertNoUserMessageBox}
          setIsVisible={setAlertNoUserMessageBox}
          text={
            <>
              To synchronize your listings actions across all devices, please{" "}
              <span
                className="active-listings-house-card-note-link"
                onClick={() => logInLinkHandler()}
              >
                create
              </span>{" "}
              an account or{" "}
              <span
                className="active-listings-house-card-note-link"
                onClick={() => logInLinkHandler()}
              >
                log in
              </span>
              .
            </>
          }
        />

        <NotesBox
          isVisible={noteBox}
          setIsVisible={setNoteBox}
          setIsNoteIconShow={setIsNoteIconShow}
          item={item}
          container={container}
        />
        {images && (
          <Slider {...settings} initialSlide={pageNumber}>
            {[...images]
              ?.sort((a, b) => parseFloat(+a.order) - parseFloat(+b.order))
              ?.map((img, i) => {
                return (
                  <div
                    key={i}
                    className="active-listings-house-card-gallery-img-container"
                    ref={ref}
                    onClick={(e) => onCLickImgSlider(i, e)}
                  >
                    {i >= 0 && (
                      <div
                        style={{
                          display:
                            // isPicturesFeature === "true" || isLogin
                            isPicturesFeature === "true" ? "none" : "block",
                        }}
                        className="active-listings-house-card-gallery-no-login-btn"
                        onClick={acceptLoginBtnHandler}
                      >
                        Click for Premium Access
                      </div>
                    )}
                    <img
                      className={
                        // isL !== "true" || !isLogin
                        isPicturesFeature !== "true"
                          ? "blur-image-inline-slider"
                          : ""
                      }
                      // loading="lazy"
                      src={img?.MediaURL ? img?.MediaURL : defaultImg}
                      onError={(e) => {
                        e.currentTarget.src =
                          "https://realtytexas.azureedge.net/assets/images/placeholder-image.jpg";
                      }}
                      onLoad={() => {
                        // if (inView) {
                        handleImageLoad(
                          i,
                          isPicturesFeature,
                          acceptLoginBtnHandler
                        );
                        // }
                      }}
                      alt={
                        img?.LongDescription
                          ? img?.LongDescription
                          : item?.Address
                          ? `${item?.Address.trim()}, ${item?.City} ${
                              item?.StateOrProvince
                            } ${item?.PostalCode}`
                          : ""
                      }
                    />
                  </div>
                );
              })}
            {images?.length < 1 && (
              <div className="active-listings-house-card-gallery-img-container">
                <img
                  src={defaultImg}
                  alt={
                    item?.Address
                      ? `${item?.Address.trim()}, ${item?.City} ${
                          item?.StateOrProvince
                        } ${item?.PostalCode}`
                      : ""
                  }
                />
              </div>
            )}
          </Slider>
        )}
        <div
          className={
            item?.OpenHouse?.length > 0
              ? "active-listings-house-card-gallery-menu-open-house-icon"
              : "active-listings-house-card-gallery-menu-label-disabled-1"
          }
        >
          <img
            onClick={() => setShowOpenHouse(true)}
            src="https://realtytexas.azureedge.net/resources/images/open-house-200.png"
            alt="open-house-200"
          />
        </div>

        {images && (
          <div className="active-listings-house-card-gallery-img-slide-counter">
            <div>{`${currentSlide}/${images.length}`}</div>{" "}
            <div className="active-listings-house-card-gallery-img-slide-counter-icon">
              <ImagesIcon color="white" height={16} width={16} />
            </div>
          </div>
        )}
        {!images && (
          <div className="active-listings-house-card-gallery-img-spiner">
            <Spiner />
          </div>
        )}
        {isHeardVisible === "true" && (
          <HouseCardHeardList
            isHeardActive={isHeardActive}
            setIsHeardActive={setIsHeardActive}
            heardData={heardData}
            index={item.ListingKeyNumeric}
            setHeardData={setHeardData}
            item={item}
            note={note}
            setNote={setNote}
            setAlertBox={setAlertBox}
            setAlertNoUserBox={setAlertNoUserBox}
            alertBox={alertBox}
            alertNoUserBox={alertNoUserBox}
            setNoteBox={setNoteBox}
            setAlertNoUserMessageBox={setAlertNoUserMessageBox}
            alertNoUserMessageBox={alertNoUserMessageBox}
            container={container}
          />
        )}

        {images && (
          <div className="active-listings-house-card-gallery-menu">
            <div className="active-listings-house-card-gallery-menu-labels">
              {item?.rtlist !== true && (
                <ClickOutside onClick={clickOutsideHandler}>
                  <div
                    className="active-listings-house-card-gallery-menu-realtytexas-icon"
                    onClick={clickRealtyIconHandler}
                  >
                    {isRI && (
                      <>
                        <div className="house-card-realty-icon-tooltip">
                          <p>Listed by Realty Texas</p>
                        </div>
                        <div className="house-card-realty-icon-tooltip-triangle" />
                      </>
                    )}
                  </div>
                </ClickOutside>
              )}

              <BAWithTooltip item={item} />
              <div className="active-listings-house-card-gallery-menu-label-2">
                <p
                  style={{
                    backgroundColor: item?.color ? item?.color : "#2078BD",
                  }}
                >
                  {item?.MlsStatus === "Closed"
                    ? `${item?.MlsStatus} - ${MachineDateToUSDate(item?.CloseDate)}`
                    : item?.MlsStatus}
                </p>
              </div>
              {/* {item?.OriginatingSystemName && (
                <div className="active-listings-house-card-gallery-menu-originating-system-name">
                  <p>{item?.OriginatingSystemName}</p>
                </div>
              )} */}
              <div
                className={
                  item?.DOM < 1
                    ? "active-listings-house-card-gallery-menu-label-1"
                    : "active-listings-house-card-gallery-menu-label-disabled-1"
                }
              >
                <p>Just Listed</p>
              </div>
            </div>

            <div className="active-listings-house-card-gallery-menu-labels-right">
              <div
                className={
                  isNoteIconShow
                    ? "active-listings-house-card-gallery-menu-note-content-icon"
                    : "active-listings-house-card-gallery-menu-note-content-icon-disabled"
                }
                onClick={onNoteContentIconHandler}
              >
                <NoteIcon className="active-listings-house-card-gallery-menu-note-content-icon-main" />
              </div>
              {isHeardVisible === "true" && (
                <div
                  className="active-listings-house-card-gallery-menu-heard-icon"
                  // onClick={onHeardIconHandler}
                  onClick={initHeardHandler}
                >
                  {getIcon()}
                </div>
              )}
              {/* {dataIsShareIcon === "false" ? null : ( */}
              <ShareIconList
                data={item}
                isHeardIconVisible={setIsHeardActive}
              />
              {/* )} */}
            </div>
          </div>
          /* <div className="active-listings-house-card-gallery-menu">
            <div className="active-listings-house-card-gallery-menu-labels">
              <ShareIconList data={item} />
              <div
                className={
                  item?.rtlist === true
                    ? "active-listings-house-card-gallery-menu-realtytexas-icon"
                    : "active-listings-house-card-gallery-menu-label-disabled-1"
                }
              />
              <div className="active-listings-house-card-gallery-menu-label-2">
                <p
                  style={{
                    backgroundColor: item?.color ? item?.color : "#2078BD",
                  }}
                >
                  {item?.MlsStatus}
                </p>
              </div>
              <div
                className={
                  item?.DOM < 1
                    ? "active-listings-house-card-gallery-menu-label-1"
                    : "active-listings-house-card-gallery-menu-label-disabled-1"
                }
              >
                <p>Just Listed</p>
              </div>
            </div>
            <div
              className={
                isNoteIconShow
                  ? "active-listings-house-card-gallery-menu-note-content-icon"
                  : "active-listings-house-card-gallery-menu-note-content-icon-disabled"
              }
              onClick={onNoteContentIconHandler}
            >
              <NoteIcon className="active-listings-house-card-gallery-menu-note-content-icon-main" />
            </div>
            {isHeardVisible === "true" && (
              <div
                className="active-listings-house-card-gallery-menu-heard-icon"
                onClick={onHeardIconHandler}
              >
                {getIcon()}
              </div>
            )}
          </div> */
        )}
      </div>
      <div
        className="active-listings-house-card-gallery-content"
        style={{ display: "none" }}
      >
        <div className="active-listings-house-card-gallery-content-price">
          <h4>
            {item?.ListPrice ? "$" : ""}
            {item?.ListPrice
              ? item?.ListPrice?.toLocaleString("en-US")?.replaceAll("$", "")
              : "No Price"}
          </h4>
        </div>
        <div className="active-listings-house-card-gallery-content-residence">
          <p>{item?.PropertyType?.replace(/([A-Z])/g, " $1")}</p>
        </div>
        <div className="active-listings-house-card-gallery-content-size">
          <span>Property Size {item?.AboveGradeFinishedArea} ft</span>
          <span>2</span>
        </div>
        <div className="active-listings-house-card-gallery-content-bd-ba">
          <div>
            <div style={{ height: "24px" }}>
              <BedIcon color="#f2f2f2" />
            </div>
            <div>
              <p>{item?.BedroomsTotal} bd</p>
            </div>
          </div>
          <div>
            <div style={{ height: "24px" }}>
              <BathroomIcon color="#f2f2f2" />
            </div>
            <div>
              <p>{item?.BathroomsFull} ba</p>
            </div>
          </div>
        </div>
        <div className="active-listings-house-card-gallery-content-adress">
          <p>
            {item?.Address ? item?.Address.trim() : ""} {item?.City}{" "}
            {item?.StateOrProvince} {item?.PostalCode}
          </p>
        </div>
        {/* <div className="active-listings-house-card-gallery-content-name">
          <p>{item?.subdomain}</p>
        </div> */}
      </div>
    </div>
  );
};

export default HouseCardGallery;

//fake heard data
// const heardData = [{ id: null, value: "delete" }];
